import type {
  SearchJourneyOffersDTO,
  SearchOffersDTO,
} from '@/types/dto/agent';
import type { OffersWarning } from '@/types/offer';

const escapeRegex = (value: string): string =>
  value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const getJourneyReferenceRegex = (
  journey: SearchJourneyOffersDTO
): RegExp | null =>
  journey.reference
    ? new RegExp(`/${escapeRegex(journey.reference)}(\\||$)`)
    : null;

export const getJourneyWarnings = (
  journey?: SearchJourneyOffersDTO,
  warnings?: SearchOffersDTO['warnings']
): OffersWarning[] => {
  if (!journey) {
    return [];
  }
  if (journey.lowestPrice) {
    // we assume no legs are giving warnings if lowestPrice exists on journey
    return [];
  }
  // "instance": "trips/reference/6b45d7dd-8997-4bd8-b283-895ea8af7409"
  // or "instance": "trips/reference/6b45d7dd-8997-4bd8-b283-895ea8af7409|0|<offerRef>"
  const regex = getJourneyReferenceRegex(journey);
  if (!regex) {
    return [];
  }
  return (
    warnings?.warnings?.filter(({ instance }) => instance?.match(regex)) ?? []
  );
};

export const getJourneyWarning = (
  journey: SearchJourneyOffersDTO,
  warnings?: SearchOffersDTO['warnings']
): OffersWarning | null => getJourneyWarnings(journey, warnings)[0] ?? null;
